var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgOnboardingIllustration1 = function SvgOnboardingIllustration1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OnboardingIllustration",
    width: 401,
    height: 366,
    viewBox: "0 0 401 366",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.431 218.649H132.529C127.52 218.649 123.458 214.588 123.458 209.579V140.196C123.458 135.187 127.52 131.126 132.529 131.126H311.431C316.441 131.126 320.501 135.187 320.501 140.196V209.579C320.501 214.588 316.441 218.649 311.431 218.649Z",
    fill: "#5C56A0",
    fillOpacity: 0.45165
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "loading1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.698 15.4346H238.576C240.509 15.4346 242.076 13.8683 242.076 11.9353C242.076 10.0028 240.509 8.43652 238.576 8.43652H186.698C184.765 8.43652 183.199 10.0028 183.199 11.9353C183.199 13.8683 184.765 15.4346 186.698 15.4346Z",
    fill: "#1487E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "loading2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.698 27.6436H238.576C240.509 27.6436 242.076 26.0773 242.076 24.1443C242.076 22.2118 240.509 20.6455 238.576 20.6455H186.698C184.765 20.6455 183.199 22.2118 183.199 24.1443C183.199 26.0773 184.765 27.6436 186.698 27.6436Z",
    fill: "#4AAFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "loading3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.698 39.8531H238.576C240.509 39.8531 242.076 38.2868 242.076 36.3538C242.076 34.4212 240.509 32.855 238.576 32.855H186.698C184.765 32.855 183.199 34.4212 183.199 36.3538C183.199 38.2868 184.765 39.8531 186.698 39.8531Z",
    fill: "#4AAFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.321 88.0424C114.87 93.5691 98.2164 88.5811 88.1788 76.7826C85.786 73.9705 83.7677 70.7705 82.2337 67.2327C81.8949 66.452 81.5793 65.6539 81.2887 64.8409C78.3677 56.6761 78.3836 48.1754 80.7889 40.4939C84.2593 29.4057 92.706 20.0207 104.488 15.8091C108.377 14.4178 112.342 13.6939 116.257 13.5744C132.429 13.0862 147.778 22.9503 153.521 39.0077C160.655 58.9561 150.268 80.9079 130.321 88.0424ZM165.576 34.6983C157.917 13.2804 137.448 0.125725 115.875 0.7744C110.652 0.931508 105.365 1.89777 100.177 3.7532C84.4636 9.37392 73.1957 21.8896 68.5663 36.6766C65.3576 46.9248 65.3378 58.2631 69.2328 69.1542C69.6198 70.2371 70.0414 71.3026 70.492 72.3436C72.5412 77.0607 75.2299 81.3277 78.4231 85.079C91.8101 100.818 114.025 107.469 134.634 100.1C161.238 90.5836 175.091 61.3036 165.576 34.6983Z",
    fill: "#4AAFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.7888 40.4939L68.5666 36.6766C73.1955 21.8896 84.4635 9.37393 100.177 3.75321C105.365 1.89779 110.652 0.931523 115.876 0.774414L116.258 13.5749C112.342 13.6939 108.377 14.4183 104.488 15.8091C92.7064 20.0212 84.2591 29.4057 80.7888 40.4939Z",
    fill: "#1A598C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2336 67.2329L70.4924 72.3433C70.0413 71.3023 69.6196 70.2368 69.2326 69.1539C65.3377 58.2633 65.3574 46.9245 68.5666 36.6768L80.7888 40.4941C78.384 48.1756 78.368 56.6763 81.2885 64.8411C81.5796 65.6541 81.8948 66.4522 82.2336 67.2329Z",
    fill: "#2273B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4234 85.0787C75.2296 81.3279 72.5415 77.0604 70.4923 72.3433L82.2335 67.2329C83.768 70.7707 85.7858 73.9703 88.1786 76.7823L78.4234 85.0787Z",
    fill: "#3788CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.225 91.8644C212.323 98.0003 205.993 101.412 199.605 100.898C198.083 100.775 196.556 100.429 195.073 99.8432C194.745 99.7135 194.42 99.5728 194.097 99.4201C190.854 97.8861 188.373 95.395 186.829 92.4446C184.601 88.1858 184.328 82.9709 186.541 78.2923C187.272 76.7482 188.22 75.3767 189.33 74.1969C193.918 69.3232 201.292 67.7188 207.669 70.7357C215.59 74.4841 218.972 83.9429 215.225 91.8644ZM209.934 65.9497C201.429 61.9251 191.595 64.0644 185.474 70.5641C183.992 72.1376 182.728 73.9666 181.754 76.0273C178.801 82.2673 179.167 89.2239 182.138 94.9034C184.196 98.8393 187.507 102.162 191.832 104.208C192.262 104.411 192.697 104.6 193.134 104.772C195.113 105.553 197.147 106.014 199.179 106.178C207.698 106.865 216.141 102.314 220.014 94.1299C225.012 83.5646 220.499 70.9482 209.934 65.9497Z",
    fill: "#4AAFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.829 92.4444L182.138 94.9032C179.167 89.2237 178.801 82.2671 181.754 76.0271C182.728 73.9664 183.992 72.1375 185.474 70.564L189.33 74.1967C188.22 75.3765 187.272 76.7481 186.541 78.2922C184.328 82.9707 184.601 88.1857 186.829 92.4444Z",
    fill: "#1A598C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.073 99.8429L193.134 104.772C192.697 104.6 192.262 104.411 191.832 104.208C187.507 102.162 184.197 98.839 182.138 94.9031L186.83 92.4443C188.373 95.3952 190.854 97.8858 194.097 99.4198C194.42 99.5725 194.745 99.7133 195.073 99.8429Z",
    fill: "#4AAFFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.179 106.178C197.147 106.014 195.112 105.553 193.134 104.772L195.073 99.8428C196.557 100.429 198.083 100.775 199.605 100.898L199.179 106.178Z",
    fill: "#4AAFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.381 120.126H154.864V119.34H193.596V102.6H194.381V120.126Z",
    fill: "#4AAFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.865 115.879H175.665V111.167H154.865V115.879Z",
    fill: "#E0E0E0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4134 60.7372C26.2871 68.7661 28.6476 74.9232 29.5387 77.847C31.8664 85.4841 32.0582 88.2572 30.9309 92.8663C29.9319 96.9516 29.0129 99.0615 27.8606 102.881C26.7073 106.701 28.6297 106.276 28.797 106.555C28.9647 106.834 67.1555 110.36 67.1555 110.36C67.1555 110.36 66.1343 102.088 63.4452 100.168C60.756 98.2466 58.0977 97.8576 60.144 89.6711C62.1893 81.4841 63.4876 77.6841 62.3411 71.7478C61.0119 64.8682 60.1758 60.569 53.7078 56.0591C49.8081 53.34 45.4264 52.7391 42.3343 53.0379C42.3343 53.0379 32.5396 52.7082 29.4134 60.7372Z",
    fill: "#3B3B40"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88,
    cy: 338,
    rx: 88,
    ry: 14,
    fill: "#494F80"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0335 323.076C31.0335 323.076 36.4214 331.076 38.592 333.005C38.592 333.005 43.4157 334.774 43.8986 338.151C44.3805 341.528 44.3005 343.782 38.592 343.943C32.8831 344.103 29.1405 343.078 28.0952 339.62C27.0499 336.163 24.7622 333.809 24.7622 333.809V341.046H23.4759C23.4759 341.046 23.154 334.051 23.0735 332.764C22.993 331.478 22.1496 326.532 24.8634 324.341C27.5761 322.151 31.0335 323.076 31.0335 323.076Z",
    fill: "#D46946"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0017 316.684C58.0017 316.684 58.9337 318.888 60.6947 321.186C61.9863 322.871 66.0017 329.789 67.7704 330.272C69.5395 330.754 75.0065 331.719 75.4894 334.775C75.9713 337.83 76.2128 340.001 70.8253 340.242C65.4388 340.483 61.9014 340.805 59.328 337.026C56.7549 333.246 52.6542 330.513 52.6542 330.513V340.373H50.5636C50.5636 340.373 49.5988 330.111 49.0359 329.387C48.4735 328.663 47.0267 320.784 52.0113 316.684C56.9959 312.582 58.0017 316.684 58.0017 316.684Z",
    fill: "#D46946"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4153 168.66C27.4153 168.66 21.3613 177.661 19.516 188.153C17.6712 198.647 19.8577 233.707 19.7767 238.892C19.6967 244.078 14.8731 256.983 15.8379 266.753C16.8028 276.522 24.8635 324.341 24.8635 324.341L31.0336 323.076C31.0336 323.076 30.4312 273.507 31.0336 269.406C31.637 265.305 32.8471 250.358 33.0881 248.67C33.3295 246.981 48.4008 202.645 48.4008 195.079C48.4008 187.514 43.8177 156.318 27.4153 168.66Z",
    fill: "#EEA886"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5879 172.116C61.5879 172.116 72.7633 214.771 74.0906 220.681C75.4168 226.59 77.3392 231.464 77.3392 233.974C77.3392 239.796 75.1759 249.144 75.1759 249.144L58.0019 316.684L50.878 317.803C50.878 317.803 54.998 276.299 55.2014 268.336C55.4038 260.355 61.5474 249.023 60.3407 245.646C59.1349 242.269 40.9233 203.313 40.9233 203.313C40.9233 203.313 27.1344 159.734 61.5879 172.116Z",
    fill: "#EEA886"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5919 333.005C38.5919 333.005 33.0757 336.09 29.5234 332.13C26.5239 328.786 24.8637 324.341 24.8637 324.341L31.0333 323.076L38.5919 333.005Z",
    fill: "#EEA886"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7701 330.272C67.7701 330.272 62.946 331.478 61.0964 330.272C59.2477 329.066 52.9605 318.439 50.8781 317.803C50.8781 317.803 52.8954 313.708 58.0014 316.684C58.0014 316.684 66.4034 328.503 67.7701 330.272Z",
    fill: "#EEA886"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.339 233.974C77.339 233.974 51.488 245.072 13.0002 245.072C13.0002 245.072 17.0537 186.754 22.6499 174.194C28.2451 161.635 62.4783 175.461 62.4783 175.461C62.4783 175.461 77.339 223.451 77.339 233.974Z",
    fill: "#494F80"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.416 149.485C106.416 149.485 82.8388 151.514 77.0051 148.916C74.0846 147.617 70.128 142.228 66.4735 136.318C65.8537 135.314 65.2407 134.294 64.6441 133.277C60.1761 125.662 56.5655 118.183 56.5655 118.183C56.5655 118.183 45.7805 104.614 57.26 99.7666C57.26 99.7666 61.7178 101.006 64.4865 105.292C67.2576 109.577 69.4239 116.009 69.9708 118.129C70.5178 120.248 79.7477 138.892 80.3265 139.418C80.9053 139.943 86.7068 139.593 91.1786 140.015C98.474 140.703 106.169 141.104 106.169 141.104L106.416 149.485Z",
    fill: "#494F80"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.593 130.552C62.6918 137.265 65.4272 139.505 64.1009 146.219C62.7737 152.934 62.3004 172.061 62.5491 175.79C62.7973 179.52 29.485 183.354 21.7747 176.557C21.7747 176.557 24.3443 162.047 29.0643 153.026C29.9616 151.313 29.5322 144.562 28.6209 142.24C28.3404 141.53 27.2248 138.785 25.8084 135.316C25.8084 135.316 25.8065 135.314 25.8041 135.31C24.3303 131.704 22.5337 127.313 21.0185 123.615C19.2243 119.236 17.8238 115.822 17.8238 115.822C17.8238 115.822 16.6735 105.02 21.1597 101.537C25.0566 98.5117 35.6749 97.4331 37.5809 96.7685C39.4879 96.1059 45.0339 95.8182 48.9308 96.397C48.9308 96.397 54.8985 99.2158 56.9718 99.6317C59.0441 100.045 67.085 110.49 68.4947 114.304C69.9028 118.117 68.4947 123.836 65.593 130.552Z",
    fill: "#494F80"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.779 89.5107C51.779 89.5107 50.5881 100.46 50.8368 104.024C50.8368 104.024 45.8489 110.086 38.7954 96.6167C38.7954 96.6167 40.5496 91.2177 38.3159 83.6534C36.0816 76.0881 51.779 89.5107 51.779 89.5107Z",
    fill: "#EEA886"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8162 97.7265C32.8162 97.7265 37.0832 110.327 48.796 109.401C60.5097 108.474 54.3497 98.7607 54.3497 98.7607C54.3497 98.7607 51.4297 97.0865 50.6081 96.9284C49.7864 96.7708 38.984 96.3125 38.984 96.3125L32.8162 97.7265Z",
    fill: "#EEA886"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.265 154.239H80.3462C79.1207 154.239 78.1269 153.245 78.1269 152.019V110.233C78.1269 109.007 79.1207 108.013 80.3462 108.013H108.265C109.492 108.013 110.485 109.007 110.485 110.233V152.019C110.485 153.245 109.492 154.239 108.265 154.239Z",
    fill: "#434343"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3263 151.096H108.285V111.156H80.3263V151.096Z",
    fill: "#4AAFFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0527 144.797C70.0527 144.797 71.1096 144.816 71.8055 144.292C73.0055 143.387 73.4383 141.158 75.5563 141.32C77.6749 141.483 78.6575 148.127 78.1269 149.385C77.5959 150.642 74.6547 151.272 70.3057 150.405C65.9583 149.539 70.0527 144.797 70.0527 144.797Z",
    fill: "#EEA886"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8296 141.366C74.8296 141.366 77.8745 140.328 81.3901 139.568C84.474 138.901 88.1588 138.683 88.5174 139.217C88.9174 139.813 85.514 140.327 82.4913 141.186C79.7092 141.975 80.3728 142.266 80.3728 142.266C80.3728 142.266 80.1887 142.173 83.3651 141.876C86.781 141.557 90.2986 141.563 90.6455 142.246C90.8142 142.578 90.6957 142.802 89.4653 143.114C90.2051 143.08 90.3092 143.272 90.3381 143.569C90.4836 145.108 85.5024 146.332 83.5241 146.818C85.046 146.454 86.1954 146.343 85.6475 147.373C85.0205 148.552 77.9121 149.979 75.4046 150.724C72.6696 151.538 74.8296 141.366 74.8296 141.366Z",
    fill: "#EEA886"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.796 116.888C106.796 116.888 111.395 115.818 112.874 118.033C114.355 120.248 114.409 123.102 114.04 124.421C113.671 125.739 112.478 129.133 110.923 128.436C105.93 126.198 106.796 116.888 106.796 116.888Z",
    fill: "#EEA886"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.348 116.936C111.348 116.936 110.704 113.828 109.46 114.359C108.214 114.89 109.339 116.941 109.339 116.941L111.348 116.936Z",
    fill: "#EEA886"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.796 116.889C106.796 116.889 106.87 115.112 110.087 116.94C113.303 118.767 106.796 116.889 106.796 116.889Z",
    fill: "#EEA886"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6442 133.273C64.6442 133.273 68.1502 124.939 68.302 123.061C68.2697 124.169 68.0196 130.918 66.4736 136.318C65.8538 135.314 65.2408 134.294 64.6442 133.277V133.273Z",
    fill: "#2B2F4D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3019 123.061C68.3039 122.957 68.3058 122.904 68.3058 122.904C68.3077 122.949 68.3058 123.001 68.3019 123.061Z",
    fill: "#D1C0BA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.321 144.801L35.7161 119.089C35.7161 119.089 40.8178 144.739 44.681 145.601C48.5427 146.463 50.321 144.801 50.321 144.801Z",
    fill: "#2B2F4D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7771 101.068C21.7771 101.068 14.7713 104.556 17.1867 113.582C19.6017 122.608 22.0051 125.203 24.312 128.579C26.4908 131.766 30.9366 140.349 31.4807 141.312C32.0248 142.275 37.3814 156.284 42.2947 157.877C47.2345 159.478 71.5588 151.729 72.1077 152.575C72.6571 153.421 72.0764 144.041 72.0764 144.041C72.0764 144.041 60.7728 144.874 58.2793 144.705C54.2282 144.43 47.7299 146.086 46.166 142.578C44.3308 138.457 37.7467 124.91 37.0537 122.679C36.3602 120.448 28.2745 98.7751 21.7771 101.068Z",
    fill: "#494F80"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9718 58.1766C49.9718 58.1766 60.7775 65.2306 57.2657 82.2817C53.753 99.3328 40.9959 89.9573 39.6103 88.9906C38.2238 88.0248 33.9414 77.353 33.7742 72.6976C33.6161 68.3135 31.3298 50.7405 49.9718 58.1766Z",
    fill: "#EEA987"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2291 61.5984C48.1014 61.2659 44.2995 68.6168 42.2513 70.4298C40.2041 72.2437 36.4402 76.797 36.071 81.7864C35.7033 86.7748 31.4927 70.8847 32.9501 64.9878C34.406 59.0915 36.3496 50.4447 49.5183 57.3025C62.6865 64.1604 59.2807 76.4211 59.2807 76.4211C59.2807 76.4211 54.9236 63.2799 49.2291 61.5984Z",
    fill: "#3B3B40"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1045 73.3683C39.7561 71.3505 35.303 69.6435 35.3691 72.6758C35.4351 75.7076 37.8934 79.2064 39.2828 78.9857C40.6732 78.7645 40.4264 75.23 40.1045 73.3683Z",
    fill: "#EEA987"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6495 89.6978C40.7285 89.8481 43.2991 94.7888 51.1651 96.0341C51.3405 94.1059 51.5849 91.745 51.5849 91.745C51.5849 91.745 45.9213 93.651 40.6495 89.6978Z",
    fill: "#A87860"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.537 206.889H161.272V148.957H152.537V206.889Z",
    fill: "#4AAFFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "line1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.228 206.889H182.964V160.729H174.228V206.889Z",
    fill: "#4AAFFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.92 206.889H204.656V152.066H195.92V206.889Z",
    fill: "#4AAFFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "line2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.613 206.89H226.348V169.169H217.613V206.89Z",
    fill: "#4AAFFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.304 206.889H248.04V153.844H239.304V206.889Z",
    fill: "#4AAFFF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "line3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.995 206.889H269.732V145.848H260.995V206.889Z",
    fill: "#4AAFFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.688 206.889H291.424V142.517H282.688V206.889Z",
    fill: "#4AAFFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.537 206.889H161.272V170.544H152.537V206.889Z",
    fill: "#3788CC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.228 206.889H182.964V177.929H174.228V206.889Z",
    fill: "#3788CC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.92 206.889H204.656V172.495H195.92V206.889Z",
    fill: "#3788CC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.613 206.889H226.348V183.225H217.613V206.889Z",
    fill: "#3788CC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.304 206.89H248.04V173.61H239.304V206.89Z",
    fill: "#3788CC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.995 206.889H269.732V168.593H260.995V206.889Z",
    fill: "#3788CC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.688 206.889H291.424V166.503H282.688V206.889Z",
    fill: "#3788CC"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnboardingIllustration1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/OnboardingIllustration1.246d83a6.svg";
export { ForwardRef as ReactComponent };